<template>
    <CompassDialog
        :visible.sync="showModal"
        size="small"
        :title="$t.__('popups.Activate2FAProvider.activate_dual_authentication')"
        class="activate-2fa"
        @closed="$emit('close')"
    >
        <template slot="default">
            <div class="dialog__default">
                <ProviderLabel2FA :provider="provider" />
                <p class="typographies-paragraph-medium-regular">
                    {{
                        $l10n.__(
                            'Vous êtes sur le point d’activer la double authentification avec Google Authenticator.',
                        )
                    }}
                </p>
                <CompassAlert
                    type="error"
                    :description="$t.__('popups.Activate2FAProvider.log_in_again_to_begin_setup')"
                    showIcon
                    :action="null"
                    :showClose="false"
                />

                <p class="m-0 gray-60">
                    {{ $l10n.__("Besoin d'aide ?") }}
                    <a
                        href="https://help.sellsy.com/fr/articles/6178777-comment-fonctionne-la-double-authentification"
                        target="_blank"
                    >
                        <span class="bold">{{ $l10n.__('Consulter notre page dédiée.') }}</span>
                    </a>
                </p>
            </div>
        </template>
        <template slot="footer">
            <div class="dialog__footer">
                <CompassButton
                    :label="$t.__('common.actions.cancel')"
                    type="secondary"
                    size="medium"
                    @click="close"
                />
                <CompassButton
                    :label="$t.__('common.actions.continue')"
                    type="primary"
                    :loading="loading"
                    class="ml-3"
                    @click="save()"
                />
            </div>
        </template>
    </CompassDialog>
</template>

<script>
import ProviderLabel2FA from 'vcomponents/ProviderLabel2FA/ProviderLabel2FA.vue';
export default {
    components: {
        ProviderLabel2FA,
    },
    props: {
        provider: {
            type: Object | null,
        },
    },
    data() {
        return {
            showModal: true,
            loading: false,
        };
    },
    methods: {
        save() {
            this.loading = true;
            const currentLocation = window.location.href;
            const redirectUrl = `redirect_url=${encodeURIComponent(currentLocation)}&provider=${
                this.provider.provider
            }`;

            ApiClient.put(
                '/settings/two-factor-authentication/user',
                {},
                {
                    providers: [
                        {
                            provider: this.provider.provider,
                        },
                    ],
                },
            )
                .then(() => {
                    window.location.href = `${window.sipHost}/login?${redirectUrl}`;
                })
                .catch(() => {
                    Push.error(this.$l10n.__('Une erreur est survenue'));
                })
                .finally(() => {
                    this.close();
                });
        },
        close() {
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@sellsy/styleguide/src/_variables';

.activate-2fa {
    .dialog {
        &__default {
            padding-bottom: 24px;
        }

        &__footer {
            display: flex;
            justify-content: flex-end;
            padding: 0 32px 24px 32px;
        }
    }

    a {
        &:hover {
            color: $primary-100;
        }
    }
}
</style>
